'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dots = require('./dots.filter');

var _dots2 = _interopRequireDefault(_dots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dotsModule = _angular2.default.module('dots.filter', []).filter('dots', _dots2.default).name;

exports.default = dotsModule;


// WEBPACK FOOTER //
// ./client/app/common/filters/dotsFilter/dots.js